import styled from "styled-components";
import { Scrollable } from "../../common/styles";

export const HomePageContainer = styled.div`
font-family: 'Nunito Sans', sans-serif;
z-index:3;
height:100vh;
width:100vw;
${Scrollable};
`;